import { render, staticRenderFns } from "./editPurchaseOrderReferenceDialog.vue?vue&type=template&id=49d97a78&"
import script from "./editPurchaseOrderReferenceDialog.vue?vue&type=script&lang=js&"
export * from "./editPurchaseOrderReferenceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports